// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreFooter_wrapper__Jg1X3","insts":"PreFooter_insts__1kiSQ","companies":"PreFooter_companies__5UFeJ","banner":"PreFooter_banner__1lBOH","footer":"PreFooter_footer__3SbfW"};